/**
 * @generated SignedSource<<c2caab57970cbe33dedd79ced0a4bc9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatePointPoolInput = {
  clientMutationId?: string | null | undefined;
  data: PointPoolInput;
};
export type PointPoolInput = {
  clientMutationId?: string | null | undefined;
  descriptionOpt?: string | null | undefined;
  name: string;
  triggersExport: boolean;
};
export type EditPointPoolScreen_CreatePointPoolMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePointPoolInput;
};
export type EditPointPoolScreen_CreatePointPoolMutation$data = {
  readonly Admin: {
    readonly Points: {
      readonly createPointPool: {
        readonly data: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"EditPointPoolScreen_PointPoolFragment">;
          };
        };
      } | null | undefined;
    };
  };
};
export type EditPointPoolScreen_CreatePointPoolMutation = {
  response: EditPointPoolScreen_CreatePointPoolMutation$data;
  variables: EditPointPoolScreen_CreatePointPoolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPointPoolScreen_CreatePointPoolMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PointsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Points",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreatePointPoolPayload",
                "kind": "LinkedField",
                "name": "createPointPool",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PointsPoolsEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PointPool",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "EditPointPoolScreen_PointPoolFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditPointPoolScreen_CreatePointPoolMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PointsAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Points",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "CreatePointPoolPayload",
                "kind": "LinkedField",
                "name": "createPointPool",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PointsPoolsEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PointPool",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "triggersExport",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "appendEdge",
                    "key": "",
                    "kind": "LinkedHandle",
                    "name": "data",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61c45b15fbc6bfa75f93bd597a009843",
    "id": null,
    "metadata": {},
    "name": "EditPointPoolScreen_CreatePointPoolMutation",
    "operationKind": "mutation",
    "text": "mutation EditPointPoolScreen_CreatePointPoolMutation(\n  $input: CreatePointPoolInput!\n) {\n  Admin {\n    Points {\n      createPointPool(input: $input) {\n        data {\n          node {\n            ...EditPointPoolScreen_PointPoolFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EditPointPoolScreen_PointPoolFragment on PointPool {\n  id\n  name\n  description\n  triggersExport\n}\n"
  }
};
})();

(node as any).hash = "8ebd3602474cf63616afc7009f5fa491";

export default node;
